"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const structure_1 = require("../../structure");
const structureValidations_1 = require("../../structureValidations");
const FieldBuilder_1 = require("./FieldBuilder");
const NodeBuilder_1 = __importDefault(require("./NodeBuilder"));
class FieldGroupBuilder extends NodeBuilder_1.default {
    seedProviders;
    constructor(seedProviders) {
        super(seedProviders.forFieldGroup());
        this.seedProviders = seedProviders;
    }
    with(nodeBuilder) {
        return this.withFields(nodeBuilder);
    }
    withFields(fieldBuilders) {
        const builders = fieldBuilders ? lodash_1.default.castArray(fieldBuilders) : [];
        if (builders.length === 0) {
            builders.push(new FieldBuilder_1.TextFieldBuilder(this.seedProviders));
        }
        const fields = builders.map((builder) => builder.build());
        this.addFields(fields);
        return this.clone();
    }
    addFields(fields) {
        if (!this.node.fields)
            this.node.fields = [];
        const fieldList = lodash_1.default.castArray(fields);
        this.node.fields.push(...fieldList);
    }
    seedWith(seed) {
        this.node = lodash_1.default.cloneDeep(seed);
        return this.clone();
    }
    makeRepeatable({ nodeId }) {
        Object.assign(this.node, this.seedProviders.forRepeatableFieldGroupOptions());
        const repeatableQuestion = this.node;
        repeatableQuestion.nodeId = nodeId;
        return this.clone();
    }
    withId(id) {
        this.node.id = id;
        return this.clone();
    }
    withMinRepetitions(minRepetitions) {
        if (!this.node.options) {
            Object.assign(this.node, this.seedProviders.forRepeatableFieldGroupOptions());
            Object.assign(this.node.options ?? {}, { minRepetitions });
        }
        else {
            Object.assign(this.node.options, { minRepetitions });
        }
        return this.clone();
    }
    withSelectTitle(nodeIds) {
        if (!this.node.options) {
            throw new Error("You can't add the 'selectTitle' property before the collection node id has been set in the options.");
        }
        if ((0, structure_1.isRepeatableOptionsWithLimits)(this.node.options)) {
            throw new Error("You can't add a 'selectTitle' property on a repeatable fieldGroup that expects a min/max limit.");
        }
        if ((0, structure_1.isRepeatableOptionsBasedOnCollection)(this.node.options)) {
            Object.assign(this.node.options, { selectTitle: nodeIds });
        }
        return this.clone();
    }
    withSelectText(nodeIds) {
        if (!this.node.options) {
            throw new Error("You can't add the 'selectText' property before the collection node id has been set in the options.");
        }
        if ((0, structure_1.isRepeatableOptionsWithLimits)(this.node.options)) {
            throw new Error("You can't add a 'selectText' property on a repeatable fieldGroup that expects a min/max limit.");
        }
        if ((0, structure_1.isRepeatableOptionsBasedOnCollection)(this.node.options)) {
            Object.assign(this.node.options, { selectText: nodeIds });
        }
        return this.clone();
    }
    withCollection(nodeId) {
        if (!this.node.options || (0, structure_1.isRepeatableOptionsWithLimits)(this.node.options)) {
            this.node.options = { expandToCollectionLength: nodeId, repeatable: true };
            return this.clone();
        }
        Object.assign(this.node.options, { expandToCollectionLength: nodeId });
        return this.clone();
    }
    withTitle(title) {
        this.node.title = title;
        return this.clone();
    }
    withText(text) {
        this.node.text = text;
        return this.clone();
    }
    visibleIf(condition) {
        this.node.visibleIf = condition;
        return this.clone();
    }
    withProperties(properties) {
        Object.assign(this.node, properties);
        return this.clone();
    }
    seedFieldsWith(fields) {
        this.node.fields = lodash_1.default.cloneDeep(fields);
        return this.clone();
    }
    validate(fieldGroup) {
        return (0, structureValidations_1.validateFieldGroup)(fieldGroup);
    }
}
exports.default = FieldGroupBuilder;
